import { PostOp3To6Months } from "..";
import { IUseAutoSaveForm, LoadingSpinner, StatefulForm, useAutoSaveForm } from "../../component-library";
import { displayDateAndTime } from "../../helper-functions";
import { FormSlugs, Tissue } from "../../models";
import { useFormDataQuery } from "../../queries";

interface TissueFollowUpProps {
    tissue: Tissue;
}

export function TissueFollowUp({ tissue }: Readonly<TissueFollowUpProps>) {
    const {
        listQuery: { data: forms, isFetching: isFormsFetching },
    } = useFormDataQuery({ caseId: tissue.caseId, tissueId: tissue.id, formSlug: FormSlugs.PostOp3To6Month });
    const formData = forms?.filter((fd) => fd.caseId === tissue.caseId && fd.tissueId === tissue.id)?.[0];

    const formState = useAutoSaveForm({ formDataId: formData?.id, isReadonlyModal: true, fetchedFormData: formData });
    const { methods } = formState;
    const formStateWithTissueId = {
        ...formState,
        formData: { ...formState.formData, ...formData, tissueId: tissue?.id, caseId: tissue?.caseId },
    } as IUseAutoSaveForm;

    return (
        <div style={{ margin: "30px 5px" }} className="no-fade">
            {isFormsFetching ? (
                <LoadingSpinner />
            ) : (
                <StatefulForm methods={methods} onSubmit={() => {}} readonly={true}>
                    <PostOp3To6Months formState={formStateWithTissueId} />
                    {formData?.signatures?.map((signature) => (
                        <div className="report-form-signature" key={signature.id}>
                            Signed:{" "}
                            <span className="text-decoration-underline">
                                {signature.userName}, {displayDateAndTime(signature.createdOn)}
                            </span>
                        </div>
                    ))}
                    <div>{tissue.number}</div>
                </StatefulForm>
            )}
        </div>
    );
}
